/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from 'react'

import {
  COLUMN_NAMES as DUEOUT_COLUMN_NAMES,
  DueOut,
  DueOutFetchArgs,
  getDueOutsViews,
} from '../../assets/ts/data/dueout/dueout'
import {
  COLUMN_NAMES as INQUIRY_COLUMN_NAMES,
  Inquiry,
  InquiryFetchArgs,
  getInquiryViews,
} from '../../assets/ts/data/inquiry/inquiry'
import { twoDigits } from '../../assets/ts/formatting/formatting'
import Buttons from '../../components/buttons/buttons'
import ExportToCSVButton from '../../components/buttons/export-to-csv-btn'
import Filters from '../../components/filters/filters'
import PageOverlayBusy from '../../components/page-overlay/page-overlay-busy'
import ArchivedDuoutsTable from '../../components/table/archived-dueout-table'
import ArchivedInquiriesTable from '../../components/table/archived-inqiries-table'
import Tabs from '../../components/tabs/tabs'
import useDueOutCount from '../../hooks/dueout/use-dueout-count'
import useDueOutDistinctValues from '../../hooks/dueout/use-dueout-distinct-values'
import useDueoutViews from '../../hooks/dueout/use-dueout-view'
import useInquiryCount from '../../hooks/inquiry/use-inquiry-count'
import useInquiryDistinctValues from '../../hooks/inquiry/use-inquiry-distinct-values'
import useInquiryViews from '../../hooks/inquiry/use-inquiry-views'
import usePageAccumulator from '../../hooks/usePageAccumulator'
import PageHeader from '../../layouts/header/page-header'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import { SelectionContext } from '../../store/selection-context-provider'
import {
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
  DUEOUT_INITIAL_FILTER,
  INQUIRY_INITIAL_FILTER,
} from '../../utils/constants/global-constants'
import NO_RESULTS from '../../utils/constants/no-results'
import InputSearch from '../../utils/controls/input-search'
import './archivedinquiries.css'

const ArchivedInquiriesList = () => {
  const selection = useContext(SelectionContext)
  const { currentPage, setCurrentPage, setPreviousPage } = useContext(PreviousPageContext)
  const { initialInquiryAndDueoutFilter } = useContext(RoleContext)

  const [exportFetchIsBusy, setExportFetchIsBusy] = useState(false)
  const [searchText, setSearchText] = useState<string>('')
  const [searchFilter, setSearchFilter] = useState<string>('')
  const [toggleTab, setToggleTab] = useState<'DUEOUTS' | 'INQUIRIES'>('INQUIRIES')
  const [activeTab, setActiveTab] = useState<'DUEOUTS' | 'INQUIRIES'>('INQUIRIES')

  const UserRoleCodes: Partial<DueOutFetchArgs | InquiryFetchArgs> = {
    userLoginRole: {
      CSSPASCODEFilter: initialInquiryAndDueoutFilter?.cssPASCODES,
      usersAssignedComponentCode: initialInquiryAndDueoutFilter?.assignedComponentCodeFilter,
      usersMajcomCodeFilter: initialInquiryAndDueoutFilter?.majcomCodeFilter,
      usersSectionCodeFilter: initialInquiryAndDueoutFilter?.sectionCodeFilter,
      usersServicingOrganizationFilter: initialInquiryAndDueoutFilter?.servicingOrganizationFilter,
      usersServicingOrganizationWithoutSectionFilter:
        initialInquiryAndDueoutFilter?.servicingOrganizationWithoutSectionFilter,
    },
  }
  const archivedInquiryFilters: InquiryFetchArgs = {
    ...INQUIRY_INITIAL_FILTER,
    ...UserRoleCodes,
    archivedFilter : ALL_SELECT_VALUE_STRING,
    archivedsearchFilter: ALL_SELECT_VALUE_STRING,
    isArchivedFilter: true,
    isViewApplied: true,
    waitOnParentDependency: true,
  }
  const archivedDueoutFilters: DueOutFetchArgs = {
    ...DUEOUT_INITIAL_FILTER,
    ...UserRoleCodes,
    archivedFilter : ALL_SELECT_VALUE_STRING,
    archivedsearchFilter: ALL_SELECT_VALUE_STRING,
    isArchivedFilter: true,
    isViewApplied: true,
    waitOnParentDependency: false,
  }
  const [inquiriesPageNum, setInquiriesPageNum] = useState(0)
  const [dueoutsPageNum, setDueoutsPageNum] = useState(0)
  const [resetFilters, setResetFilters] = useState(true)
  const [displayArchivedTable, setDisplayArchivedTable] = useState<boolean>(false)
  const [issearchSelected, setIssearchSelected] = useState<boolean>(false)
  const [isDropDownSelected, setIsDropDownSelected] = useState<boolean>(false)
  const [inquiryFilter, setInquiryFilter] = useState<InquiryFetchArgs>({
    ...archivedInquiryFilters,
  })
  const [dueoutFilter, setDueoutFilter] = useState<DueOutFetchArgs>({
    ...archivedDueoutFilters,
  })

  const inquiryPaging: InquiryFetchArgs = {
    pageNumber: inquiriesPageNum,
  }
  const dueOutPaging: DueOutFetchArgs = {
    pageNumber: dueoutsPageNum,
  }
  const { inquiries, inquiriesAreLoading } = useInquiryViews({
    ...inquiryFilter,
    ...inquiryPaging,
  })
  const { dueouts, dueoutsAreLoading } = useDueoutViews({
    ...dueoutFilter,
    ...dueOutPaging,
  })
  const { inquiryCountIsLoading, inquiryCountValue } = useInquiryCount({
    ...inquiryFilter,
  })
  const { dueOutCountIsLoading, dueOutCountValue } = useDueOutCount({
    ...dueoutFilter,
  })
  const accumulatedInquiries = usePageAccumulator(inquiriesPageNum, inquiries)
  const accumulatedDueOuts = usePageAccumulator(dueoutsPageNum, dueouts)
  const handleBottomInquiryScroll = () => {
    if (inquiryCountValue > accumulatedInquiries.length) {
      setInquiriesPageNum((num) => num + 1)
    }
  }
  const handleBottomDueoutScroll = () => {
    if (dueOutCountValue > accumulatedDueOuts.length) {
      setDueoutsPageNum((num) => num + 1)
    }
  }

  const tableitems = [
    activeTab === 'INQUIRIES'
      ? {
          content: (
            <ArchivedInquiriesTable
              csvTitle={'ARCHIVED INQUIRIES'}
              inquiries={accumulatedInquiries}
              onBottomScrollReached={handleBottomInquiryScroll}
            />
          ),
          count: twoDigits(inquiryCountValue),
          isActive: activeTab === 'INQUIRIES',
          tabTitle: 'Archived Inquiries',
        }
      : {
          content: (
            <ArchivedDuoutsTable
              dueOuts={accumulatedDueOuts}
              onBottomScrollReached={handleBottomDueoutScroll}
              title='Total Due Outs'
            />
          ),
          count: twoDigits(dueOutCountValue),
          isActive: activeTab === 'DUEOUTS',
          tabTitle: 'DUE OUTS',
        },
  ]

  const onSearchClick = () => {
    const searchInput = searchText.trim()
    if (searchInput !== ALL_SELECT_VALUE_STRING) {
      setSearchFilter(searchInput)
      setIsDropDownSelected(false)
      setActiveTab(toggleTab === 'INQUIRIES' ? 'INQUIRIES' : 'DUEOUTS')
      setResetFilters(!resetFilters)
      setDisplayArchivedTable(true)
      handleClearAll()
      activeTab === 'INQUIRIES'
        ? setInquiryFilter({
            ...archivedInquiryFilters,
            archivedsearchFilter: searchInput,
            waitOnParentDependency: false,
          })
        : setDueoutFilter({
            ...archivedDueoutFilters,
            archivedsearchFilter: searchInput,
            waitOnParentDependency: false,
          })
    }
  }
  const onChangeSearch = (e: { target: { value: string } } | undefined) => {
    if (e) setSearchText(e.target.value)
    else onSearchClick()
  }
  const toggleFunction = (e: { target: { checked: boolean } }) => {
    setToggleTab(e.target.checked ? 'DUEOUTS' : 'INQUIRIES')
  }
  const handleClearAll = () => {
    setInquiryFilter({
      ...archivedInquiryFilters,
      archivedsearchFilter: searchText,
      waitOnParentDependency: false,
    })
    setDueoutFilter({
      ...archivedDueoutFilters,
      archivedsearchFilter: searchText,
      waitOnParentDependency: false,
    })
    setInquiriesPageNum(0)
    setDueoutsPageNum(0)
    // selection.reset()
  }
  const { inquiryDistinctValues, inquiryDistinctValuesAreLoading } = useInquiryDistinctValues({
    archivedsearchFilter: searchFilter,
    assignedComponentCodeFilter: inquiryFilter.assignedComponentCodeFilter,
    categoryCodeFilter: inquiryFilter.categoryCodeFilter as number,
    currentlyServicingByFilter: inquiryFilter.currentlyServicingByFilter,
    distinctFiltersToQuery: [
      INQUIRY_COLUMN_NAMES.FY,
      INQUIRY_COLUMN_NAMES.AssignedComponentCode,
      INQUIRY_COLUMN_NAMES.ServicingMAJCOMCode,
      INQUIRY_COLUMN_NAMES.CurrentlyServicingBy,
      INQUIRY_COLUMN_NAMES.ServicingOrganization,
      INQUIRY_COLUMN_NAMES.SectionCode,
      INQUIRY_COLUMN_NAMES.CategoryCode,
      INQUIRY_COLUMN_NAMES.SubCategoryCode,
    ],
    isArchivedFilter: true,
    isViewApplied: true,
    sectionCodeFilter: inquiryFilter.sectionCodeFilter,
    servicingMAJCOMCodeFilter: inquiryFilter.servicingMAJCOMCodeFilter,
    servicingOrganizationFilter: inquiryFilter.servicingOrganizationFilter,
    subCategoryCodeFilter: inquiryFilter.subCategoryFilter as number,
  })
  const { dueOutDistinctValues, dueOutDistinctValuesAreLoading } = useDueOutDistinctValues({
    archivedsearchFilter: searchFilter,
    assignedComponentCodeFilter: dueoutFilter.assignedComponentCodeFilter,
    categoryCodeFilter: dueoutFilter.categoryCodeFilter as number,
    distinctFiltersToQuery: [
      DUEOUT_COLUMN_NAMES.FY,
      DUEOUT_COLUMN_NAMES.AssignedComponentCode,
      DUEOUT_COLUMN_NAMES.ServicingMAJCOMCode,
      DUEOUT_COLUMN_NAMES.ServicingOrganization,
      DUEOUT_COLUMN_NAMES.ServicingBy,
      DUEOUT_COLUMN_NAMES.SectionCode,
      DUEOUT_COLUMN_NAMES.CategoryCode,
      DUEOUT_COLUMN_NAMES.SubCategoryCode,
      DUEOUT_COLUMN_NAMES.Priority,
    ],
    isArchivedFilter: true,
    isViewApplied: true,
    sectionCodeFilter: dueoutFilter.sectionCodeFilter,
    servicingByFilter: dueoutFilter.servicingByFilter,
    servicingMAJCOMCodeFilter: dueoutFilter.servicingMAJCOMCodeFilter,
    servicingOrganizationFilter: dueoutFilter.servicingOrganizationFilter,
    subCategoryCodeFilter: dueoutFilter.subCategoryCodeFilter as number,
  })
  const resetFilterOptions = (priorArgs, order, updatedArgs) => ({
    ...priorArgs,
    assignedComponentCodeFilter:
      order && order >= 2 ? priorArgs.assignedComponentCodeFilter : ALL_SELECT_VALUE,
    categoryCodeFilter: order && order >= 9 ? priorArgs.categoryCodeFilter : ALL_SELECT_VALUE,
    currentlyServicingByFilter:
      order && order >= 4 ? priorArgs.currentlyServicingByFilter : ALL_SELECT_VALUE_STRING,
    sectionCodeFilter: order && order >= 8 ? priorArgs.sectionCodeFilter : ALL_SELECT_VALUE,
    servicingByFilter: order && order >= 4 ? priorArgs.servicingByFilter : ALL_SELECT_VALUE_STRING,
    servicingMAJCOMCodeFilter:
      order && order >= 3 ? priorArgs.servicingMAJCOMCodeFilter : ALL_SELECT_VALUE,
    servicingOrganizationFilter:
      order && order >= 5 ? priorArgs.servicingOrganizationFilter : ALL_SELECT_VALUE_STRING,
    subCategoryCodeFilter:
      order && order >= 10 ? priorArgs.subCategoryCodeFilter : ALL_SELECT_VALUE,
    ...updatedArgs,
  })
  const updateInquiryFilter = (updatedArgs, order) => {
    selection.reset()
    setIsDropDownSelected(true)
    setInquiriesPageNum(0)
    setInquiryFilter((priorArgs) => resetFilterOptions(priorArgs, order, updatedArgs))
  }
  const updateDueoutFilter = (updatedArgs, order) => {
    selection.reset()
    setIsDropDownSelected(true)
    setDueoutsPageNum(0)
    setDueoutFilter((priorArgs) => resetFilterOptions(priorArgs, order, updatedArgs))
  }
  async function getAllSelectedRecords(): Promise<Inquiry[]> {
    const visibleSelectedRecords = accumulatedInquiries.filter((d) =>
      selection.keyIsSelected(d.InquiryGUID ?? '')
    )
    const unloadedSelectedRecords = await getAllUnloadedSelectedRecords()

    const allSelectedRecords = [...visibleSelectedRecords, ...unloadedSelectedRecords]
    return allSelectedRecords
  }
  async function getAllDueoutSelectedRecords(): Promise<DueOut[]> {
    const visibleSelectedRecords = accumulatedDueOuts.filter((d) =>
      selection.keyIsSelected(d.DueOutGUID ?? '')
    )

    const unloadedSelectedRecords = await getAllDueoutsUnloadedSelectedRecords()

    const allSelectedRecords = [...visibleSelectedRecords, ...unloadedSelectedRecords]

    return allSelectedRecords
  }
  async function getAllUnloadedSelectedRecords(): Promise<Inquiry[]> {
    if (selection.unloadedRecordsAreSelected) {
      setExportFetchIsBusy(true)
      const items = await getInquiryViews({
        ...inquiryFilter,
        onePageOnly: false,
        pageNumber: (inquiryPaging.pageNumber ?? 0) + 1,
      })
      setExportFetchIsBusy(false)
      return items
    } else {
      return []
    }
  }
  async function getAllDueoutsUnloadedSelectedRecords(): Promise<DueOut[]> {
    if (selection.unloadedRecordsAreSelected) {
      setExportFetchIsBusy(true)
      const items = await getDueOutsViews({
        ...dueoutFilter,
        onePageOnly: false,
        pageNumber: (dueOutPaging.pageNumber ?? 0) + 1,
      })
      setExportFetchIsBusy(false)
      return items
    } else {
      return []
    }
  }
  const busy =
    inquiriesAreLoading ||
    inquiryCountIsLoading ||
    dueoutsAreLoading ||
    dueOutCountIsLoading ||
    inquiryDistinctValuesAreLoading ||
    dueOutDistinctValuesAreLoading ||
    exportFetchIsBusy

  useEffect(() => {
    if (activeTab === 'INQUIRIES') {
      selection.mergeWithAllLoadedRecordKeys(inquiries.map((i) => i.InquiryGUID ?? ''))
    }
  }, [inquiries, activeTab])

  useEffect(() => {
    if (activeTab === 'DUEOUTS') {
      selection.mergeWithAllLoadedRecordKeys(dueouts.map((i) => i.DueOutGUID ?? ''))
    }
  }, [dueouts, activeTab])

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Store the previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes
  const ExportToCSVButtonVisibility = (): boolean => {
    if (activeTab === 'INQUIRIES') {
      return inquiryCountValue > 0 ? true : false
    } else {
      return dueOutCountValue > 0 ? true : false
    }
  }
  return (
    <>
      {busy && <PageOverlayBusy />}
      <PageHeader
        extras={<div></div>}
        icon='icon-archivedinquiries font-14 me-1 color-primary'
        name='Archived Inquiries '
      />

      <div className='container'>
        <div
          className={`row ${
            displayArchivedTable
              ? ''
              : 'd-flex flex-wrap flex-column flex-sm-row justify-content-center mt-4 align-items-start'
          }`}
        >
          <div className='col-sm-12 col-lg listview-table'>
            <div className={displayArchivedTable ? 'w-100 h-100' : ''}>
              <div className='card-body'>
                <div className='container'>
                  <div className='row'>
                    <div className='col-sm-12 archivedsearch mt-0'>
                      <div className='align-items-center d-flex flex-wrap'>
                        <div className='col-xl-3 col-12 col swtich'>
                          <div className='filters hometoggle d-flex align-items-center mb-4'>
                            <label
                              aria-label='Inquiries'
                              className='poppins-medium font-12 title-color'
                              htmlFor='InquiriesLabel'
                              tabIndex={0}
                            >
                              Inquiries
                            </label>
                            <label className='dueoutswitch'>
                              <input
                                aria-label='dueoutswitch'
                                id='toggleHome'
                                onChange={(e) => toggleFunction(e)}
                                type='checkbox'
                              />
                              <span className='dueoutslider round'></span>
                            </label>
                            <label
                              aria-label='Due Outs'
                              className='poppins-medium font-12 subtitle-color dimmed'
                              htmlFor='DueOutsLabel'
                              tabIndex={0}
                            >
                              Due Outs
                            </label>
                            <div className='dueouttoggledivider'></div>
                          </div>
                        </div>
                        <div className='col-xl-9 col-12 col searchform'>
                          <div className='w-100 text-center'>
                            <h2
                              aria-label='Archived'
                              className='latobold font-20 title-color maxfitcontent text-center d-none mb-2 '
                              tabIndex={0}
                            >
                              Archived{' '}
                              <span
                                className='tool-tip tooltip-bottom font-12 sourcesanspro'
                                data-tip='Archived'
                              >
                                <span className='icon-info color-primary font-15 ps-1'></span>
                              </span>
                            </h2>
                            <div className='mx-2 mb-1'>
                              <InputSearch
                                className='no-border w-100 sourcesanspro font-13 title-color19 px-5 border-radius3'
                                formClassName='mt-1 px-2 w-100'
                                icon='icon-send font-15 pe-1'
                                iconClick={onSearchClick}
                                iconanchorclass='bannersend'
                                inputProps={{
                                  arialabel: 'search',
                                  label: 'true',
                                  placeholder: 'Archived Inquiries/Due Outs',
                                }}
                                label=''
                                licon='icon-qasearch color-primary left-searchicon font-16 fw-bold '
                                liconanchorclass='bannersearch'
                                onChange={(e) => onChangeSearch(e)}
                                onKeyDown={(e: React.KeyboardEvent) => {
                                  if (e.key === 'Enter') {
                                    onChangeSearch(undefined)
                                  }
                                }}
                                search='Search'
                                searchgroup='bordered2 w-100 d-flex align-items-center border-radius3 overflow-hidden inputswithicon archivedsearchicon'
                                send='Send'
                              />

                              <p className='sourcesanspro font-12 title-color my-2 d-inline-block'>
                                <span className='color-primary'>Hint: </span>
                                Search Inquiries by ID, Customer Name, Section, Title, Category, Sub
                                Category, or Servicing Organization{' '}
                              </p>
                            </div>
                            <div className='d-none align-items-center w-100 justify-content-center'>
                              <Buttons
                                className='btn-lg btn-border-radius3 montserratbold font-md-12 text-uppercase px-3 bgcolor-primary whitetext'
                                label='Search'
                                type='button'
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      {!isDropDownSelected && displayArchivedTable &&
                        (activeTab === 'INQUIRIES'
                          ? inquiryCountValue === 0
                          : dueOutCountValue === 0) && <NO_RESULTS />}
                    </div>
                  </div>
                </div>
                {(isDropDownSelected  || (activeTab === 'INQUIRIES' ? inquiryCountValue > 0 : dueOutCountValue > 0)) && displayArchivedTable && (
                  <Tabs
                    anchorclass='title-color font-12 poppins-semibold'
                    badge='badge bgcolor-primary font-12 border-radius3 px-2 py-1 whitetext'
                    className='title-color lg'
                    isButtons={
                      ExportToCSVButtonVisibility() ? (
                        <ExportToCSVButton
                          fetchDataFunc={
                            activeTab === 'INQUIRIES'
                              ? getAllSelectedRecords
                              : getAllDueoutSelectedRecords
                          }
                          pageType={
                            activeTab === 'INQUIRIES' ? 'Archived/Inquiries' : 'Archived/Dueouts'
                          }
                        />
                      ) : (
                        ''
                      )
                    }
                    items={tableitems}
                    tablistclassName='overflow-auto'
                  />
                )}{' '}
                {/* {displayArchivedTable &&  (activeTab === 'INQUIRIES' ? inquiryCountValue > 0 :  dueOutCountValue > 0) && <NO_RESULTS />} */}
              </div>
            </div>
          </div>
          {(isDropDownSelected  || (activeTab === 'INQUIRIES' ? inquiryCountValue > 0 : dueOutCountValue > 0)) && displayArchivedTable && (
            <div className='col-sm-12 listview-filters order-first order-lg-0'>
              <div className='w-100 whitebg bordered1'>
                <div className='filter-section mb-3'>
                  <Filters
                    availableFilterValues={
                      activeTab === 'INQUIRIES' ? inquiryDistinctValues[0] : dueOutDistinctValues[0]
                    }
                    filter={activeTab === 'INQUIRIES' ? inquiryFilter : dueoutFilter}
                    onClearAll={handleClearAll}
                    onUpdateFilter={
                      activeTab === 'INQUIRIES' ? updateInquiryFilter : updateDueoutFilter
                    }
                    pageType={activeTab === 'INQUIRIES' ? 'Archived/Inquiries' : 'Archived/Dueouts'}
                    resetFilters={resetFilters}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
export default ArchivedInquiriesList
